import clsx from 'clsx';
import React, { useRef } from 'react';
import { useClickAway } from 'react-use';
import { getSpreadsheetErrorMsg } from '@/utils/spreadsheets';
import longFormCellSelectionUtils from '@/utils/reporting/longFormCellSelection';
import List, { Item } from '@/components/lists/Indicator';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

const ErrorsList = _ref => {
  let {
    isVisible,
    errors,
    sheetNames = [],
    onClose,
    onSelect
  } = _ref;
  const refDrawer = useRef(null); // Close drawer on click outside

  useClickAway(refDrawer, e => {
    var _refDrawer$current;

    const target = e.target;
    if (target !== null && target !== void 0 && target.dataset.ignoreClickAway) return;
    if (refDrawer !== null && refDrawer !== void 0 && (_refDrawer$current = refDrawer.current) !== null && _refDrawer$current !== void 0 && _refDrawer$current.contains(target)) return;
    onClose();
  }); // NOTE: container must always be rendered for slide
  //       in animation to display consistently

  return /*#__PURE__*/_jsx("aside", {
    ref: refDrawer,
    className: clsx(styles.drawer, isVisible && styles['drawer--animate']),
    children: isVisible ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs("header", {
        className: styles.header,
        children: [/*#__PURE__*/_jsx("h5", {
          className: styles.heading,
          children: "Workbook Errors"
        }), /*#__PURE__*/_jsx("p", {
          className: styles.subHeading,
          children: "Issues detected that can affect widget results"
        })]
      }), /*#__PURE__*/_jsx(List, {
        className: styles.body,
        children: errors === null || errors === void 0 ? void 0 : errors.map((error, idx) => {
          // Create human-friendly cell reference
          const cellRef = longFormCellSelectionUtils.toUserFacingSelection(error.cellRef, {
            sheetNames,
            addSheetRef: error.cellRef.search(/^[1-9]\./) > -1
          });
          return /*#__PURE__*/_jsx(Item, {
            className: styles.item,
            title: `${cellRef} - #${error.code}`,
            message: getSpreadsheetErrorMsg(error.code),
            variant: "alert",
            callToAction: "Select",
            onSelect: () => onSelect(error)
          }, `${error.code}-${idx}`);
        })
      }), /*#__PURE__*/_jsx("footer", {
        className: styles.footer,
        children: /*#__PURE__*/_jsx("button", {
          className: styles.closeButton,
          onClick: onClose,
          children: "Close Errors"
        })
      })]
    }) : /*#__PURE__*/_jsx(_Fragment, {})
  });
};

export default ErrorsList;